import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
// import $ from 'jquery';

import SearchTabs from '~/components/legacy/SearchTabs.jsx';
import SearchTab from '~/components/legacy/SearchTab.jsx';
import SearchTabContent from '~/components/legacy/SearchTabContent.jsx';
import SearchTabFilterContent from '~/components/legacy/SearchTabFilterContent.jsx';
import SearchTabProFilterContent from '~/components/legacy/SearchTabProFilterContent.jsx';
import SearchMenuLengthInputs from '~/components/legacy/SearchMenuLengthInputs.jsx';
import SearchMenuQueryInput from '~/components/legacy/SearchMenuQueryInput.jsx';
import { parseReactProps } from '~/components/legacy/reactProps.js';
import { requestJson } from '~/modules/legacyRequest.js';
import legacyEventHub from '~/modules/legacyRuntime.js';

const MOBILE_STICKY_BREAKPOINT = 568;
const MOBILE_STICKY_LAYER_TOP_PADDING = 8;
const SEARCH_SCROLL_ANIMATION_DURATION = 400;

class Search extends Component {

  constructor(props) {
    super(props);

    this.searchRef = null;
    this.stickyRegionRef = null;
    this.stickyUpdateFrame = null;
    this.stickyPortalHost = null;
    this.lastInlineStickyHeight = 0;
    this.resultsScrollFrameHandle = null;
    this.eventHubListeners = [];

    this.setSearchRef = element => {
      this.searchRef = element;
    };

    this.setStickyRegionRef = element => {
      this.stickyRegionRef = element;
    };

    this.handleTempoChange = this.handleTempoChange.bind(this);
    this.toggleTempoSearch = this.toggleTempoSearch.bind(this);
    this.handleSubmitSearchClick = this.handleSubmitSearchClick.bind(this);
    this.submitQueryClick = this.submitQueryClick.bind(this);
    this.submitMenuItemClick = this.submitMenuItemClick.bind(this);
    this.submitQueryChange = this.submitQueryChange.bind(this);
    this.submitMinLengthClick = this.submitMinLengthClick.bind(this);
    this.submitMaxLengthClick = this.submitMaxLengthClick.bind(this);
    this.submitLengthChange = this.submitLengthChange.bind(this);
    this.submitExtendedFilterChange = this.submitExtendedFilterChange.bind(this);
    this.submitProFilterChange = this.submitProFilterChange.bind(this);
    this.handleIncludeProCheckboxChange = this.handleIncludeProCheckboxChange.bind(this);
    this.isExtendedFilterChecked = this.isExtendedFilterChecked.bind(this);
    this.isProFilterChecked = this.isProFilterChecked.bind(this);
    this.isQuickStartFilterActive = this.isQuickStartFilterActive.bind(this);
    this.hasActiveQuickStartFilters = this.hasActiveQuickStartFilters.bind(this);
    this.submitQuickStartFilterClick = this.submitQuickStartFilterClick.bind(this);
    this.resetQuickStartFilters = this.resetQuickStartFilters.bind(this);
    this.toggleQuickFilterModeFilters = this.toggleQuickFilterModeFilters.bind(this);
    this.toggleMobileFilters = this.toggleMobileFilters.bind(this);
    this.renderQuickStartScopeToggle = this.renderQuickStartScopeToggle.bind(this);
    this.renderQuickStartFilters = this.renderQuickStartFilters.bind(this);
    this.renderSortSelect = this.renderSortSelect.bind(this);
    this.sendPaginationSearchQuery = this.sendPaginationSearchQuery.bind(this);
    this.handleSortSelectChange = this.handleSortSelectChange.bind(this);
    this.handleSearchTabChange = this.handleSearchTabChange.bind(this);
    this.handleStickyFiltersScroll = this.handleStickyFiltersScroll.bind(this);
    this.updateStickyFilters = this.updateStickyFilters.bind(this);
    this.resetStickyFilters = this.resetStickyFilters.bind(this);
    this.handlePopState = this.handlePopState.bind(this);
    this.scheduleResultsScroll = this.scheduleResultsScroll.bind(this);
    this.scrollResultsToListingHeading = this.scrollResultsToListingHeading.bind(this);

    this.state = {
      ...this.buildInitialSearchState(),
      quickFiltersExpanded: !this.props.quickFilterMode,
      mobileFiltersExpanded: false,
      activeTab: 0,
      stickyFiltersActive: false,
      stickyPlaceholderHeight: 0,
      stickyLayerStyle: null,
    };
  }

  buildInitialSearchState() {
    const initialSearchQuery = this.props.initialSearchQuery || {};
    const initialState = {
      query: '',
      genres: [],
      instruments: [],
      moods: [],
      tags: [],
      instoreTags: [],
      minTempo: 80,
      maxTempo: 140,
      tempoSearchActive: false,
      page: initialSearchQuery.page ? parseInt(initialSearchQuery.page, 10) : 1,
      composers: [],
      completedQuery: '',
      minLength: '',
      maxLength: '',
      free: false,
      sortDirection: this.props.sortDirection || '',
      exposurePackId: '',
      mediaBundleId: '',
      labelId: '',
      albumId: '',
      sortBy: this.props.sortBy || '',
      trackId: initialSearchQuery.track_id || initialSearchQuery.trackId || '',
      extendedFilters: {
        drums: 0,
        vocals: 0,
        withVariants: 0,
        loop: 0
      },
      proFilter: this.normalizeProFilterValue(initialSearchQuery.include_pro)
    };

    ['genres', 'instruments', 'moods', 'tags', 'instoreTags', 'composers'].forEach((key) => {
      if (Array.isArray(initialSearchQuery[key])) {
        initialState[key] = initialSearchQuery[key].slice();
      }
    });

    if (typeof initialSearchQuery.query === 'string' && initialSearchQuery.query.length > 0) {
      initialState.query = initialSearchQuery.query;
      initialState.completedQuery = initialSearchQuery.query;
    }

    if (initialSearchQuery.tempoSearchActive) {
      if (initialSearchQuery.minTempo > 0) {
        initialState.minTempo = initialSearchQuery.minTempo;
      }

      if (initialSearchQuery.maxTempo > 0) {
        initialState.maxTempo = initialSearchQuery.maxTempo;
      }

      initialState.tempoSearchActive = true;
    }

    if (initialSearchQuery.minLength >= 0) {
      initialState.minLength = initialSearchQuery.minLength;
    }

    if (parseInt(initialSearchQuery.maxLength, 10) >= 0) {
      initialState.maxLength = initialSearchQuery.maxLength;
    }

    if (initialSearchQuery.exposurePackId) {
      initialState.exposurePackId = initialSearchQuery.exposurePackId;
    }

    if (initialSearchQuery.mediaBundleId) {
      initialState.mediaBundleId = initialSearchQuery.mediaBundleId;
    }

    if (initialSearchQuery.labelId) {
      initialState.labelId = initialSearchQuery.labelId;
    }

    if (initialSearchQuery.albumId) {
      initialState.albumId = initialSearchQuery.albumId;
    }

    if (initialSearchQuery.free) {
      initialState.free = initialSearchQuery.free;
    }

    return initialState;
  }

  defaultProFilterValue() {
    const configuredDefault = parseInt(this.props.proScopeDefaultValue, 10);

    if (!isNaN(configuredDefault)) {
      return configuredDefault;
    }

    return this.props.proScopeCheckboxEnabled ? 0 : 2;
  }

  royaltyFreeProScopeValue() {
    const configuredValue = parseInt(this.props.proScopeRoyaltyFreeValue, 10);

    if (!isNaN(configuredValue)) {
      return configuredValue;
    }

    return 2;
  }

  normalizeProFilterValue(value) {
    if (value === true || value === 'true') {
      return 0;
    }

    if (value === false || value === 'false') {
      return 2;
    }

    let parsedValue = parseInt(value, 10);

    if (parsedValue === 0) {
      return 0;
    }

    if (parsedValue === 2) {
      return 2;
    }

    if (parsedValue === this.royaltyFreeProScopeValue() || parsedValue === this.defaultProFilterValue()) {
      return parsedValue;
    }

    if (!isNaN(parsedValue) && !this.props.proScopeCheckboxEnabled && [1, 3].includes(parsedValue)) {
      return parsedValue;
    }

    // Legacy values (1/3) and unknown values map to "all tracks" for backwards compatibility.
    if (!isNaN(parsedValue)) {
      return 0;
    }

    return this.defaultProFilterValue();
  }

  UNSAFE_componentWillMount() {
    this.setState(this.buildInitialSearchState());
  }

  componentDidMount() {
    this.setStateViaUrlParams();
    window.addEventListener('popstate', this.handlePopState);

    this.registerEventHubListener('queryInputSubmit', function () {
      this.sendSearchQuery();
    }.bind(this));

    this.registerEventHubListener('paginationClick', this.sendPaginationSearchQuery);

    this.registerEventHubListener('changeSort', function (payload) {
      if (payload[0]) {
        this.setState({ sortDirection: payload[0].sortDirection, sortBy: payload[0].sortBy }, function () {
          this.sendSearchQuery();
        });
      }
    }.bind(this));

    this.registerEventHubListener('trackTagClick', function (payload) {
      if (payload[0]) {
        if (this.state.tags.indexOf(payload[0]) > -1) {
          let index = this.state.tags.indexOf(payload[0]);
          let tags = this.state.tags;

          tags.splice(index, 1)

          this.setState({ tags: tags }, function () {
            this.sendSearchQuery();
          });

        } else {
          this.setState({ tags: [payload[0]] }, function () {
            this.sendSearchQuery();
          });
        }

      }
    }.bind(this));

    this.registerEventHubListener('trackGenreClick', function (payload) {
      if (payload[0]) {
        if (this.state.genres.indexOf(payload[0]) > -1) {
          let index = this.state.genres.indexOf(payload[0]);
          let genres = this.state.genres;

          genres.splice(index, 1)

          this.setState({ genres: genres }, function () {
            this.sendSearchQuery();
          });

        } else {
          this.setState({ genres: [payload[0]] }, function () {
            this.sendSearchQuery();
          });
        }
      }
    }.bind(this));

    this.registerEventHubListener('trackMoodClick', function (payload) {
      if (payload[0]) {
        if (this.state.moods.indexOf(payload[0]) > -1) {
          let index = this.state.moods.indexOf(payload[0]);
          let moods = this.state.moods;

          moods.splice(index, 1)

          this.setState({ moods: moods }, function () {
            this.sendSearchQuery();
          });

        } else {
          this.setState({ moods: [payload[0]] }, function () {
            this.sendSearchQuery();
          });
        }

      }
    }.bind(this));

    this.registerEventHubListener('requestUpdateTrackListing', function () {
      this.sendSearchQuery(true, true);
    }.bind(this));

    this.registerEventHubListener('trackProScopeClick', function (payload) {
      let eventPayload = Array.isArray(payload) ? payload[0] : payload;
      let value = eventPayload && typeof eventPayload.includePro !== 'undefined' ? eventPayload.includePro : eventPayload;
      this.submitProFilterChange(this.normalizeProFilterValue(value));
    }.bind(this));
  }

  componentWillUnmount() {
    this.unregisterEventHubListeners();
    window.removeEventListener('popstate', this.handlePopState);

    if (this.stickyUpdateFrame !== null && typeof window !== 'undefined') {
      const cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
      cancelFrame(this.stickyUpdateFrame);
      this.stickyUpdateFrame = null;
    }

    if (this.resultsScrollFrameHandle !== null && typeof window !== 'undefined') {
      const cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
      cancelFrame(this.resultsScrollFrameHandle);
      this.resultsScrollFrameHandle = null;
    }
  }

  registerEventHubListener(eventName, handler) {
    const eventHub = this.eventHub();
    if (!eventHub || typeof eventHub.on !== 'function') {
      return;
    }

    eventHub.on(eventName, handler);
    this.eventHubListeners.push({ eventName: eventName, handler: handler });
  }

  unregisterEventHubListeners() {
    const eventHub = this.eventHub();

    if (!eventHub || typeof eventHub.off !== 'function') {
      this.eventHubListeners = [];
      return;
    }

    this.eventHubListeners.forEach(function(listener) {
      eventHub.off(listener.eventName, listener.handler);
    });
    this.eventHubListeners = [];
  }

  eventHub() {
    return legacyEventHub;
  }

  triggerEventHub(eventName, ...args) {
    const eventHub = this.eventHub();
    if (!eventHub || typeof eventHub.trigger !== 'function') {
      return;
    }

    eventHub.trigger(eventName, ...args);
  }

  parseIntegerArrayParam(searchParams, key) {
    return searchParams.getAll(key)
      .map((value) => parseInt(value, 10))
      .filter((value) => !isNaN(value));
  }

  parseOptionalIntegerParam(searchParams, key, fallback = '') {
    let value = parseInt(searchParams.get(key), 10);
    return isNaN(value) ? fallback : value;
  }

  buildSearchStateFromLocation(searchString = '') {
    const searchParams = new URLSearchParams(searchString || '');
    const nextState = this.buildInitialSearchState();
    const query = searchParams.get('q') || '';
    const genreIds = this.parseIntegerArrayParam(searchParams, 'genre_id[]');
    const instrumentIds = this.parseIntegerArrayParam(searchParams, 'instrument_id[]');
    const moodIds = this.parseIntegerArrayParam(searchParams, 'mood_id[]');
    const tagIds = this.parseIntegerArrayParam(searchParams, 'tag_id[]');
    const instoreTagIds = this.parseIntegerArrayParam(searchParams, 'instore_tag_id[]')
      .concat(this.parseIntegerArrayParam(searchParams, 'instoreTag_id[]'));
    const composerIds = this.parseIntegerArrayParam(searchParams, 'composer_id[]');
    const minTempo = this.parseOptionalIntegerParam(searchParams, 'min_tempo');
    const maxTempo = this.parseOptionalIntegerParam(searchParams, 'max_tempo');
    const minLength = this.parseOptionalIntegerParam(searchParams, 'min_length');
    const maxLength = this.parseOptionalIntegerParam(searchParams, 'max_length');
    const page = this.parseOptionalIntegerParam(searchParams, 'page', 1);
    const includePro = searchParams.get('include_pro');

    nextState.query = query;
    nextState.completedQuery = query;
    nextState.genres = genreIds.length > 0 ? genreIds : nextState.genres;
    nextState.instruments = instrumentIds.length > 0 ? instrumentIds : nextState.instruments;
    nextState.moods = moodIds.length > 0 ? moodIds : nextState.moods;
    nextState.tags = tagIds.length > 0 ? tagIds : nextState.tags;
    nextState.instoreTags = instoreTagIds.length > 0 ? Array.from(new Set(instoreTagIds)) : nextState.instoreTags;
    nextState.composers = composerIds.length > 0 ? composerIds : nextState.composers;
    nextState.minLength = !isNaN(minLength) ? minLength : '';
    nextState.maxLength = !isNaN(maxLength) ? maxLength : '';
    nextState.minTempo = !isNaN(minTempo) ? minTempo : 80;
    nextState.maxTempo = !isNaN(maxTempo) ? maxTempo : 140;
    nextState.tempoSearchActive = !isNaN(minTempo) || !isNaN(maxTempo);
    nextState.page = page > 0 ? page : 1;
    nextState.free = searchParams.get('free') === 'true';
    nextState.labelId = this.parseOptionalIntegerParam(searchParams, 'label_id', nextState.labelId);
    nextState.trackId = this.parseOptionalIntegerParam(searchParams, 'track_id', nextState.trackId);
    nextState.exposurePackId = this.parseOptionalIntegerParam(searchParams, 'exposure_pack_id', nextState.exposurePackId);
    nextState.mediaBundleId = this.parseOptionalIntegerParam(searchParams, 'media_bundle_id', nextState.mediaBundleId);
    nextState.albumId = this.parseOptionalIntegerParam(searchParams, 'album_id', nextState.albumId);
    nextState.sortBy = searchParams.get('sort_by') || nextState.sortBy;
    nextState.sortDirection = searchParams.get('sort_direction') || nextState.sortDirection;
    nextState.extendedFilters = {
      drums: this.parseOptionalIntegerParam(searchParams, 'drums', 0),
      vocals: this.parseOptionalIntegerParam(searchParams, 'vocals', 0),
      withVariants: this.parseOptionalIntegerParam(searchParams, 'with_variants', 0),
      loop: this.parseOptionalIntegerParam(searchParams, 'loop', 0)
    };

    if (includePro !== null) {
      nextState.proFilter = this.normalizeProFilterValue(includePro);
    }

    return nextState;
  }

  syncItemIdList(searchState = this.state) {
    this.triggerEventHub('updateItemIdList', {
      genres: searchState.genres,
      tags: searchState.tags,
      moods: searchState.moods,
      instoreTags: searchState.instoreTags,
      minLength: searchState.minLength,
      maxLength: searchState.maxLength,
      loop: searchState.extendedFilters.loop,
      includePro: searchState.proFilter,
      noFiltersActive: this.getActiveSearchCriteriaCountWithHiddenCriterias(searchState) === 0 && this.isDefaultScopeSelected(searchState)
    });
  }

  handlePopState() {
    const nextSearchState = this.buildSearchStateFromLocation(window.location.search);
    const paginationMode = (nextSearchState.page || 1) > 1;

    this.setState(nextSearchState, function() {
      this.syncItemIdList(nextSearchState);
      this.sendSearchQuery(paginationMode, false, { skipHistoryPush: true, skipResultsScroll: true, useAnimationlessUpdate: true });
    }.bind(this));
  }

  createStickyPortalHost() {
    if (typeof document === 'undefined' || this.stickyPortalHost) {
      return;
    }

    this.stickyPortalHost = document.createElement('div');
    this.stickyPortalHost.className = 'search__sticky-portal-host';
    document.body.appendChild(this.stickyPortalHost);
  }

  destroyStickyPortalHost() {
    if (!this.stickyPortalHost || typeof document === 'undefined') {
      return;
    }

    if (this.stickyPortalHost.parentNode) {
      this.stickyPortalHost.parentNode.removeChild(this.stickyPortalHost);
    }

    this.stickyPortalHost = null;
  }

  handleStickyFiltersScroll() {
    if (typeof window === 'undefined') {
      return;
    }

    const requestFrame = window.requestAnimationFrame || function(callback) {
      return window.setTimeout(callback, 0);
    };

    if (this.stickyUpdateFrame !== null) {
      return;
    }

    this.stickyUpdateFrame = requestFrame(function() {
      this.stickyUpdateFrame = null;
      this.updateStickyFilters();
    }.bind(this));
  }

  handleSearchTabChange(activeTab) {
    this.setState({
      activeTab: activeTab
    });
  }

  getStickyTopOffset() {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return 0;
    }

    const nodes = Array.from(document.querySelectorAll('.nav, .minimal-header, .global-coupon'));

    return nodes.reduce(function(maxBottom, node) {
      if (!node) {
        return maxBottom;
      }

      const computedStyle = window.getComputedStyle(node);
      if (!(computedStyle.position === 'fixed' || computedStyle.position === 'sticky')) {
        return maxBottom;
      }

      const rect = node.getBoundingClientRect();
      if (rect.bottom <= 0) {
        return maxBottom;
      }

      return Math.max(maxBottom, rect.bottom);
    }, 0);
  }

  getStickyBoundaryNode() {
    if (!this.searchRef || typeof this.searchRef.closest !== 'function') {
      return null;
    }

    const stickyLayout = this.searchRef.closest('.search-sticky-layout');
    if (stickyLayout) {
      return stickyLayout.querySelector('#track-listing') || stickyLayout;
    }

    const listingContainer = this.searchRef.closest('#track-listing-container');
    if (listingContainer) {
      return listingContainer.querySelector('#track-listing') || listingContainer;
    }

    return null;
  }

  resetStickyFilters() {
    if (!this.stickyRegionRef) {
      return;
    }

    if (!this.state.stickyFiltersActive && this.state.stickyPlaceholderHeight === 0) {
      return;
    }

    this.setState({
      stickyFiltersActive: false,
      stickyPlaceholderHeight: 0,
      stickyLayerStyle: null
    });
  }

  getStickyMeasureNode() {
    if (this.state.stickyFiltersActive && this.stickyPortalHost) {
      const portalInputsNode = this.stickyPortalHost.querySelector('.search__inputs');
      if (portalInputsNode) {
        return portalInputsNode;
      }
    }

    if (!this.stickyRegionRef) {
      return null;
    }

    return this.stickyRegionRef.querySelector('.search__inputs');
  }

  getInlineStickyMeasureNode() {
    if (!this.stickyRegionRef || typeof this.stickyRegionRef.querySelector !== 'function') {
      return null;
    }

    return this.stickyRegionRef.querySelector('.search__inputs:not(.search__inputs--sticky-clone)');
  }

  isMobileStickyViewport() {
    if (typeof window === 'undefined') {
      return false;
    }

    return window.innerWidth <= MOBILE_STICKY_BREAKPOINT;
  }

  getStickyLayerTopPadding() {
    return this.isMobileStickyViewport() ? MOBILE_STICKY_LAYER_TOP_PADDING : 0;
  }

  getResultsScrollAnchorNode() {
    if (typeof document === 'undefined') {
      return null;
    }

    return document.querySelector('.track-listing__count') ||
      document.querySelector('#track-listing') ||
      document.querySelector('.track-listing');
  }

  getResultsScrollStickyOverlapHeight() {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return 0;
    }

    const stickyNodes = Array.from(document.querySelectorAll('.nav, .minimal-header, .search__sticky-layer, .search__sticky-layer .search__inputs'));
    const stickyRects = stickyNodes
      .filter(function(node) {
        return node && typeof node.getBoundingClientRect === 'function';
      })
      .map(function(node) {
        const rect = node.getBoundingClientRect();
        const computedStyle = window.getComputedStyle ? window.getComputedStyle(node) : null;
        const isStickyPosition = computedStyle && (computedStyle.position === 'sticky' || computedStyle.position === 'fixed');
        const configuredTop = computedStyle && computedStyle.top && computedStyle.top !== 'auto' ? parseFloat(computedStyle.top) : rect.top;

        return {
          top: Number.isFinite(configuredTop) ? configuredTop : rect.top,
          bottom: (Number.isFinite(configuredTop) ? configuredTop : rect.top) + rect.height,
          height: rect.height,
          isStickyPosition: isStickyPosition
        };
      })
      .filter(function(rect) {
        return rect.height > 0 && rect.isStickyPosition;
      })
      .sort(function(left, right) {
        return left.top - right.top;
      });

    let overlapBottom = 0;

    stickyRects.forEach(function(rect) {
      const top = Math.max(rect.top, 0);
      const bottom = Math.max(rect.bottom, 0);

      if (top <= overlapBottom + 1) {
        overlapBottom = Math.max(overlapBottom, bottom);
      }
    });

    return overlapBottom;
  }

  getAnticipatedSearchStickyOverlapHeight() {
    const topOffset = this.getStickyTopOffset();

    if (topOffset <= 0) {
      return 0;
    }

    const stickyMeasureNode = this.getInlineStickyMeasureNode() || this.getStickyMeasureNode();
    if (!stickyMeasureNode || typeof stickyMeasureNode.getBoundingClientRect !== 'function') {
      return topOffset;
    }

    const measuredStickyHeight = Math.ceil(stickyMeasureNode.getBoundingClientRect().height) + this.getStickyLayerTopPadding();
    const stickyHeight = this.state.stickyPlaceholderHeight > 0 ? this.state.stickyPlaceholderHeight : measuredStickyHeight;

    return topOffset + stickyHeight;
  }

  scrollResultsToListingHeading(triggerType = 'search') {
    const anchorNode = this.getResultsScrollAnchorNode();
    if (!anchorNode || typeof anchorNode.getBoundingClientRect !== 'function') {
      return;
    }

    const actualStickyOverlapHeight = this.getResultsScrollStickyOverlapHeight();
    const stickyOverlapHeight = triggerType === 'search'
      ? Math.max(actualStickyOverlapHeight, this.getAnticipatedSearchStickyOverlapHeight())
      : actualStickyOverlapHeight;
    const anchorRect = anchorNode.getBoundingClientRect();
    const currentScrollTop = window.pageYOffset || window.scrollY || 0;
    const anchorTop = anchorRect.top + currentScrollTop;
    const scrollTarget = Math.max(anchorTop - stickyOverlapHeight - 16, 0);
    const scrollDelta = Math.abs(currentScrollTop - scrollTarget);
    const minimumDelta = triggerType === 'search' ? 4 : 48;

    if (scrollDelta < minimumDelta) {
      return;
    }

    if (typeof window.scrollTo === 'function') {
      window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
      return;
    }

    window.scrollTo(0, scrollTarget);
  }

  scheduleResultsScroll(triggerType = 'search') {
    if (typeof window === 'undefined') {
      return;
    }

    const requestFrame = window.requestAnimationFrame || function(callback) {
      return window.setTimeout(callback, 0);
    };
    const cancelFrame = window.cancelAnimationFrame || window.clearTimeout;

    if (this.resultsScrollFrameHandle !== null) {
      cancelFrame(this.resultsScrollFrameHandle);
    }

    this.resultsScrollFrameHandle = requestFrame(function() {
      this.resultsScrollFrameHandle = requestFrame(function() {
        this.resultsScrollFrameHandle = null;
        this.scrollResultsToListingHeading(triggerType);
      }.bind(this));
    }.bind(this));
  }

  updateStickyFilters() {
    if (typeof window === 'undefined' || !this.searchRef || !this.stickyRegionRef) {
      return;
    }

    const stickyInputsNode = this.getStickyMeasureNode();
    if (!stickyInputsNode) {
      return;
    }

    const inlineStickyInputsNode = this.getInlineStickyMeasureNode();

    const boundaryNode = this.getStickyBoundaryNode();
    const topOffset = this.getStickyTopOffset();
    const regionRect = this.stickyRegionRef.getBoundingClientRect();
    const boundaryRect = boundaryNode ? boundaryNode.getBoundingClientRect() : null;
    const measuredStickyHeight = Math.ceil(stickyInputsNode.getBoundingClientRect().height) + this.getStickyLayerTopPadding();
    if (inlineStickyInputsNode && typeof inlineStickyInputsNode.getBoundingClientRect === 'function') {
      this.lastInlineStickyHeight = Math.ceil(inlineStickyInputsNode.getBoundingClientRect().height);
    }
    const stickyHeight = this.isMobileStickyViewport() ? Math.max(measuredStickyHeight, this.lastInlineStickyHeight) : measuredStickyHeight;
    let stickyLayerStyle;

    if (this.isMobileStickyViewport()) {
      stickyLayerStyle = {
        left: '0px',
        top: `${Math.round(topOffset)}px`,
        width: `${Math.round(window.innerWidth)}px`
      };
    } else {
      stickyLayerStyle = {
        left: `${Math.round(regionRect.left)}px`,
        top: `${Math.round(topOffset)}px`,
        width: `${Math.round(regionRect.width)}px`
      };
    }
    const shouldFix = regionRect.top <= topOffset && (!boundaryRect || boundaryRect.bottom > topOffset + stickyHeight + 24);

    if (!shouldFix) {
      this.resetStickyFilters();
      return;
    }

    const currentStickyStyle = this.state.stickyLayerStyle || {};
    const stickyStyleChanged = currentStickyStyle.left !== stickyLayerStyle.left ||
      currentStickyStyle.top !== stickyLayerStyle.top ||
      currentStickyStyle.width !== stickyLayerStyle.width;

    if (
      this.state.stickyFiltersActive &&
      this.state.stickyPlaceholderHeight === stickyHeight &&
      !stickyStyleChanged
    ) {
      return;
    }

    this.setState({
      stickyFiltersActive: true,
      stickyPlaceholderHeight: stickyHeight,
      stickyLayerStyle: stickyLayerStyle
    });
  }

  sendPaginationSearchQuery(pageNumber) {
    this.setState({ page: pageNumber }, function () {
      this.sendSearchQuery(true);
    });
  }

  setStateViaUrlParams() {
    let nextSearchState = this.buildSearchStateFromLocation(document.location.search);

    this.setState(nextSearchState, function() {
      this.syncItemIdList(nextSearchState);
    }.bind(this));
  }

  setQueryFromUrl() {
    let regex = /\q\=([\w\+\d\%,-]*)/g,
      matches = regex.exec(document.location.search),
      matchesLength,
      queryText;

    if (matches !== null) {
      matchesLength = matches.length;
      for (let i = 0; i < matchesLength; i += 1) {
        queryText = matches[i].replace(/\+/g, ' ');
      }
      this.setState({ query: decodeURI(queryText), completedQuery: decodeURI(queryText) });
    }
  }

  setLabelFromUrl() {
    let labelRegex = /label_id\=([\d]*)/g,
      labelMatches = labelRegex.exec(document.location.search),
      labelMatchesLength,
      labelId;

    if (labelMatches !== null) {
      labelMatchesLength = labelMatches.length;
      for (let i = 0; i < labelMatchesLength; i += 1) {
        labelId = labelMatches[i];
      }
    }

    if (labelId) {
      this.setState({
        labelId: labelId
      });
    }

  }

  setIdsFromUrlFor(paramString) {
    let pattern = '\_id\\[\\]\\=(\\d)+',
      regex = new RegExp(paramString + pattern, 'gi'),
      matches = document.location.search.match(regex),
      ids = [],
      stateObject = {},
      matchesLength,
      matchId,
      i;

    if (matches !== null) {
      matchesLength = matches.length;
      for (i = 0; i < matchesLength; i += 1) {
        matchId = parseInt(matches[i].replace(paramString + '_id[]=', ''), 10);
        ids.push(matchId);
      }
      stateObject[paramString + 's'] = ids;
      this.setState(stateObject, function () {
        setTimeout(function () {
          this.syncItemIdList();
        }.bind(this), 50)
      });
    }
  }

  setTempoFromUrl() {
    let minRegex = /min_tempo\=([\d]*)/g,
      minMatches = minRegex.exec(document.location.search),
      minMatchesLength,
      minQueryText,

      maxRegex = /max_tempo\=([\d]*)/g,
      maxMatches = maxRegex.exec(document.location.search),
      maxMatchesLength,
      maxQueryText;

    if (minMatches !== null) {
      minMatchesLength = minMatches.length;
      for (let i = 0; i < minMatchesLength; i += 1) {
        minQueryText = minMatches[i];
      }
    }

    if (maxMatches !== null) {
      maxMatchesLength = maxMatches.length;
      for (let i = 0; i < maxMatchesLength; i += 1) {
        maxQueryText = maxMatches[i];
      }
    }

    if (minQueryText) {
      this.setState({
        minTempo: minQueryText,
        tempoSearchActive: true
      });
    }

    if (maxQueryText) {
      this.setState({
        maxTempo: maxQueryText,
        tempoSearchActive: true
      });
    }
  }

  setExtendedFiltersFromUrl() {
    let drumRegex = /drums\=([\d]*)/g,
      drumMatches = drumRegex.exec(document.location.search),
      drumMatchesLength,
      drumValue,

      vocalRegex = /vocals\=([\d]*)/g,
      vocalMatches = vocalRegex.exec(document.location.search),
      vocalMatchesLength,
      vocalValue,

      variantsRegex = /with_variants\=([\d]*)/g,
      variantsMatches = variantsRegex.exec(document.location.search),
      variantsMatchesLength,
      variantsValue,

      loopRegex = /loop\=([\d]*)/g,
      loopMatches = loopRegex.exec(document.location.search),
      loopMatchesLength,
      loopValue,

      shouldUpdate = false,

      stateObject = this.state;

    if (drumMatches !== null) {
      drumMatchesLength = drumMatches.length;
      for (let i = 0; i < drumMatchesLength; i += 1) {
        drumValue = drumMatches[i];
      }
    }

    if (drumValue) {
      stateObject.extendedFilters.drums = parseInt(drumValue, 10);
      if (this.state.extendedFiters && this.state.extendedFiters.drums !== stateObject.extendedFilters.drums) {
        shouldUpdate = true;
      }
    }

    if (vocalMatches !== null) {
      vocalMatchesLength = vocalMatches.length;
      for (let i = 0; i < vocalMatchesLength; i += 1) {
        vocalValue = vocalMatches[i];
      }
    }

    if (vocalValue) {
      stateObject.extendedFilters.vocals = parseInt(vocalValue, 10);
      if (this.state.extendedFiters && this.state.extendedFiters.vocals !== stateObject.extendedFilters.vocals) {
        shouldUpdate = true;
      }
    }

    let includeProParam = new URLSearchParams(document.location.search).get('include_pro');

    if (includeProParam !== null) {
      stateObject.proFilter = this.normalizeProFilterValue(includeProParam);
      if (this.state.proFilter !== stateObject.proFilter) {
        shouldUpdate = true;
      }
    }

    if (variantsMatches !== null) {
      variantsMatchesLength = variantsMatches.length;
      for (let i = 0; i < variantsMatchesLength; i += 1) {
        variantsValue = variantsMatches[i];
      }
    }

    if (variantsValue) {
      stateObject.extendedFilters.withVariants = parseInt(variantsValue, 10);
      if (this.state.extendedFiters && this.state.extendedFiters.withVariants !== stateObject.extendedFilters.withVariants) {
        shouldUpdate = true;
      }
    }

    if (loopMatches !== null) {
      loopMatchesLength = loopMatches.length;
      for (let i = 0; i < loopMatchesLength; i += 1) {
        loopValue = loopMatches[i];
      }
    }

    if (loopValue) {
      stateObject.extendedFilters.loop = parseInt(loopValue, 10);
      if (this.state.extendedFiters && this.state.extendedFiters.loop !== stateObject.extendedFilters.loop) {
        shouldUpdate = true;
      }
    }

    if (shouldUpdate) {
      this.setState(stateObject);
    }
  }

  setLengthFromUrl() {
    let minRegex = /min_length\=([\d]*)/g,
      minMatches = minRegex.exec(document.location.search),
      minMatchesLength,
      minQueryText,

      maxRegex = /max_length\=([\d]*)/g,
      maxMatches = maxRegex.exec(document.location.search),
      maxMatchesLength,
      maxQueryText;

    if (minMatches !== null) {
      minMatchesLength = minMatches.length;
      for (let i = 0; i < minMatchesLength; i += 1) {
        minQueryText = minMatches[i];
      }
    }

    if (maxMatches !== null) {
      maxMatchesLength = maxMatches.length;
      for (let i = 0; i < maxMatchesLength; i += 1) {
        maxQueryText = maxMatches[i];
      }
    }

    if (minQueryText) {
      this.setState({
        minLength: parseInt(minQueryText, 10)
      });
    }

    if (maxQueryText) {
      this.setState({
        maxLength: parseInt(maxQueryText, 10)
      });
    }
  }

  setSortFromUrl() {
    let directionRegex = /sort_direction\=([a-zA-Z]+)/g,
      directionMatches = directionRegex.exec(document.location.search),
      directionMatchesLength,
      directionQueryText;

    if (directionMatches !== null) {
      directionMatchesLength = directionMatches.length;
      for (let i = 0; i < directionMatchesLength; i += 1) {
        directionQueryText = directionMatches[i];
      }
    }

    let sortByRegex = /sort_by\=([a-zA-Z]+)/g,
      sortByMatches = sortByRegex.exec(document.location.search),
      sortByMatchesLength,
      sortByQueryText;

    if (sortByMatches !== null) {
      sortByMatchesLength = sortByMatches.length;
      for (let i = 0; i < sortByMatchesLength; i += 1) {
        sortByQueryText = sortByMatches[i];
      }
    }


    if (sortByQueryText && directionQueryText) {
      this.setState({
        sortDirection: directionQueryText,
        sortBy: sortByQueryText
      });
    } else if (directionQueryText) {
      this.setState({
        sortDirection: directionQueryText
      });
    }
  }

  handleTempoChange(minTempo, maxTempo, active) {
    this.setState({
      minTempo: minTempo,
      maxTempo: maxTempo,
      tempoSearchActive: active
    });

    this.sendSearchQuery();
  }

  toggleTempoSearch(e) {
    e.preventDefault();

    this.setState({
      tempoSearchActive: !this.state.tempoSearchActive,
    });

    setTimeout(function () {
      this.sendSearchQuery();
    }.bind(this), 1)
  }

  handleSubmitSearchClick() {
    this.sendSearchQuery();
  }

  submitQueryClick(query) {
    let stateObject = this.state;

    stateObject.query = '';
    stateObject.completedQuery = '';

    this.setState(stateObject);
    this.sendSearchQuery();
  }

  submitMenuItemClick(name, id) {
    let stateObject = this.state,
      arrayLength = stateObject[name].length,
      i,
      removeIndex,
      shouldAddToArray = true;

    for (i = 0; i < arrayLength; i += 1) {
      if (stateObject[name][i] === id) {
        shouldAddToArray = false;
      }
    }

    if (shouldAddToArray) {
      if (name === 'moods' || name === 'instruments') {
        stateObject[name].push(id);
      } else {
        stateObject[name] = [id];
      }
    } else {
      removeIndex = stateObject[name].indexOf(id);
      if (removeIndex > -1) {
        stateObject[name].splice(removeIndex, 1);
      }
    }

    this.setState(stateObject);
    this.sendSearchQuery();
  }

  isQuickStartFilterActive(filter) {
    let categoryItems = this.state[filter.category] || [];

    return categoryItems.indexOf(filter.id) > -1;
  }

  hasQuickStartFilters() {
    return !!(this.props.quickStartFilters && this.props.quickStartFilters.items && this.props.quickStartFilters.items.length > 0);
  }

  hasActiveQuickStartFilters() {
    if (!this.props.quickStartFilters || !this.props.quickStartFilters.items) {
      return false;
    }

    return this.props.quickStartFilters.items.some(function (filter) {
      return this.isQuickStartFilterActive(filter);
    }.bind(this));
  }

  quickStartFilterIdsByCategory(category) {
    if (!this.props.quickStartFilters || !this.props.quickStartFilters.items) {
      return [];
    }

    return this.props.quickStartFilters.items
      .filter(function (filter) {
        return filter.category === category;
      })
      .map(function (filter) {
        return filter.id;
      });
  }

  submitQuickStartFilterClick(filter, event) {
    let stateObject = this.state,
      category = filter.category,
      categoryItems = stateObject[category] || [],
      quickStartIds = this.quickStartFilterIdsByCategory(category),
      isActive = categoryItems.indexOf(filter.id) > -1,
      preservedCategoryItems = categoryItems.filter(function (id) {
        return quickStartIds.indexOf(id) === -1;
      });

    event.preventDefault();

    // Quick start filters should behave like curated shortcuts:
    // one active quick filter per category, without dropping manually selected filters.
    stateObject[category] = isActive ? preservedCategoryItems : preservedCategoryItems.concat([filter.id]);

    this.setState(stateObject);
    this.sendSearchQuery();
  }

  resetQuickStartFilters(event) {
    let stateObject = this.state;

    event.preventDefault();

    if (!this.props.quickStartFilters || !this.props.quickStartFilters.items) {
      return;
    }

    this.props.quickStartFilters.items.forEach(function (filter) {
      let quickStartIds = this.quickStartFilterIdsByCategory(filter.category),
        categoryItems = stateObject[filter.category] || [];

      stateObject[filter.category] = categoryItems.filter(function (id) {
        return quickStartIds.indexOf(id) === -1;
      });
    }.bind(this));

    this.setState(stateObject);
    this.sendSearchQuery();
  }

  toggleQuickFilterModeFilters(event) {
    event.preventDefault();

    this.setState({
      quickFiltersExpanded: !this.state.quickFiltersExpanded
    });
  }

  toggleMobileFilters(event) {
    event.preventDefault();

    this.setState({
      mobileFiltersExpanded: !this.state.mobileFiltersExpanded
    });
  }

  shouldShowMobilePrimaryScopeToggle() {
    return this.props.proScopeCheckboxEnabled && !this.props.includeProSwitchInQuickFilters;
  }

  usesExplicitMobilePrimaryFilters() {
    return Array.isArray(this.props.mobilePrimaryFilters) && this.props.mobilePrimaryFilters.length > 0;
  }

  mobilePrimaryFilters() {
    if (this.usesExplicitMobilePrimaryFilters()) {
      return this.props.mobilePrimaryFilters;
    }

    return ['tags', 'moods'];
  }

  shouldShowTagsFilter() {
    return true;
  }

  shouldShowGenresFilter() {
    return true;
  }

  shouldShowMoodsFilter() {
    return true;
  }

  shouldShowInstrumentsFilter() {
    return true;
  }

  shouldShowExtendedFilters() {
    return true;
  }

  shouldShowLengthFilter() {
    return true;
  }

  shouldShowQueryFilter() {
    return true;
  }

  shouldShowSortFilter() {
    return true;
  }

  shouldShowMobilePrimaryTagsTab() {
    if (!this.shouldShowTagsFilter()) {
      return false;
    }

    if (this.usesExplicitMobilePrimaryFilters()) {
      return this.mobilePrimaryFilters().includes('tags');
    }

    return this.props.hideCategoryFromUrl !== 'tag';
  }

  shouldShowMobilePrimaryGenresTab() {
    if (!this.shouldShowGenresFilter()) {
      return false;
    }

    if (this.usesExplicitMobilePrimaryFilters()) {
      return this.mobilePrimaryFilters().includes('genres');
    }

    return false;
  }

  shouldShowMobilePrimaryMoodsTab() {
    if (!this.shouldShowMoodsFilter()) {
      return false;
    }

    if (this.usesExplicitMobilePrimaryFilters()) {
      return this.mobilePrimaryFilters().includes('moods');
    }

    return this.props.hideCategoryFromUrl !== 'mood';
  }

  shouldUseTwoColumnMobilePrimaryTabs() {
    return [
      this.shouldShowMobilePrimaryTagsTab(),
      this.shouldShowMobilePrimaryGenresTab(),
      this.shouldShowMobilePrimaryMoodsTab()
    ].filter(Boolean).length === 2;
  }

  mobilePrimaryFilterPosition(name) {
    let visiblePrimaryFilters = [];

    if (this.shouldShowMobilePrimaryTagsTab()) {
      visiblePrimaryFilters.push('tags');
    }

    if (this.shouldShowMobilePrimaryGenresTab()) {
      visiblePrimaryFilters.push('genres');
    }

    if (this.shouldShowMobilePrimaryMoodsTab()) {
      visiblePrimaryFilters.push('moods');
    }

    return visiblePrimaryFilters.indexOf(name);
  }

  shouldShowMobileFiltersToggle() {
    if (!this.shouldShowExtendedFilters() && !this.shouldShowGenresFilter() && !this.shouldShowInstrumentsFilter() && !this.shouldShowLengthFilter() && !this.shouldShowQueryFilter() && !this.shouldShowSortFilter()) {
      return false;
    }

    if (this.shouldShowTagsFilter() && !this.shouldShowMobilePrimaryTagsTab()) {
      return true;
    }

    if (this.shouldShowMoodsFilter() && !this.shouldShowMobilePrimaryMoodsTab()) {
      return true;
    }

    if (!this.shouldShowMobilePrimaryScopeToggle() && !this.props.proScopeCheckboxEnabled) {
      return true;
    }

    return this.shouldShowExtendedFilters() || this.shouldShowGenresFilter() || this.shouldShowInstrumentsFilter() || this.shouldShowLengthFilter() || this.shouldShowQueryFilter() || this.shouldShowSortFilter();
  }

  hasActiveExtendedFilters() {
    return this.state.extendedFilters.drums !== 0 || this.state.extendedFilters.vocals !== 0 || this.state.extendedFilters.withVariants !== 0 || this.state.extendedFilters.loop !== 0;
  }

  hasNonDefaultSort() {
    return this.state.sortBy !== 'popularity' || this.state.sortDirection !== 'desc';
  }

  getMobileAdvancedFiltersCount() {
    if (!this.shouldShowMobileFiltersToggle()) {
      return 0;
    }

    let count = 0;

    if (this.shouldShowTagsFilter() && !this.shouldShowMobilePrimaryTagsTab()) {
      count += this.state.tags.length;
    }

    if (this.shouldShowMoodsFilter() && !this.shouldShowMobilePrimaryMoodsTab()) {
      count += this.state.moods.length;
    }

    if (!this.shouldShowMobilePrimaryScopeToggle() && this.state.proFilter !== this.defaultProFilterValue()) {
      count += 1;
    }

    if (this.shouldShowGenresFilter() && !this.shouldShowMobilePrimaryGenresTab()) {
      count += this.state.genres.length;
    }

    if (this.shouldShowInstrumentsFilter()) {
      count += this.state.instruments.length;
    }

    if (this.shouldShowQueryFilter() && (this.state.query || '').length > 0) {
      count += 1;
    }

    if (this.shouldShowLengthFilter() && this.state.minLength > 0) {
      count += 1;
    }

    if (this.shouldShowLengthFilter() && this.state.maxLength > 0) {
      count += 1;
    }

    if (this.shouldShowExtendedFilters() && this.hasActiveExtendedFilters()) {
      count += 1;
    }

    if (this.shouldShowSortFilter() && this.hasNonDefaultSort()) {
      count += 1;
    }

    return count;
  }

  renderMobileFiltersToggle() {
    if (!this.shouldShowMobileFiltersToggle()) {
      return null;
    }

    let activeFilterCount = this.getMobileAdvancedFiltersCount();
    let label = this.props.locale === 'de' ? 'Erweiterte Suche' : 'Advanced search';

    if (this.state.mobileFiltersExpanded) {
      label = this.props.locale === 'de' ? 'Erweiterte Suche ausblenden' : 'Hide advanced search';
    } else if (activeFilterCount > 0) {
      label += ' (+' + activeFilterCount + ')';
    }

    return (
      <button
        type='button'
        className={this.state.mobileFiltersExpanded ? 'button button--text-inline search__mobile-filters-toggle search__mobile-filters-toggle--active' : 'button button--text-inline search__mobile-filters-toggle'}
        onClick={this.toggleMobileFilters}
      >
        <span className='search__mobile-filters-toggle-label'>{label}</span>
        <span className='search__mobile-filters-toggle-icon' aria-hidden='true' />
      </button>
    );
  }

  renderQuickStartScopeToggle() {
    if (!this.props.quickFilterMode || !this.props.includeProSwitchInQuickFilters || !this.props.proScopeCheckboxEnabled) {
      return null;
    }

    return (
      <div className='search-license-scope-toggle search__quick-start-scope-toggle'>
        <button
          type='button'
          className={this.state.proFilter === this.royaltyFreeProScopeValue() ? 'search-license-scope-toggle__option search-license-scope-toggle__option--active' : 'search-license-scope-toggle__option'}
          onClick={this.activateGemafreeScope.bind(this)}
        >
          <span className='search-license-scope-toggle__label'>
            {this.proScopeLabel('royaltyFree')}
          </span>
        </button>
        <button
          type='button'
          className={this.state.proFilter === 0 ? 'search-license-scope-toggle__option search-license-scope-toggle__option--active' : 'search-license-scope-toggle__option'}
          onClick={this.activateAllTracksScope.bind(this)}
        >
          <span className='search-license-scope-toggle__label'>
            {this.proScopeLabel('all')}
          </span>
        </button>
      </div>
    );
  }

  renderQuickStartFilters() {
    let items,
      resetLabel,
      toggleLabel,
      toggleButtonLabel;

    if (!this.props.quickStartFilters || !this.props.quickStartFilters.items || this.props.quickStartFilters.items.length === 0) {
      return null;
    }

    resetLabel = this.props.quickStartFilters.resetLabel || this.props.quickStartFilters.reset_label;
    toggleLabel = this.props.quickStartFilters.toggleLabel || this.props.quickStartFilters.toggle_label;
    toggleButtonLabel = this.state.quickFiltersExpanded ? this.props.quickStartFilters.expandedToggleLabel || this.props.quickStartFilters.expanded_toggle_label || toggleLabel : toggleLabel;

    items = this.props.quickStartFilters.items.map(function (filter, index) {
      let filterClasses = classNames({
        'tag': true,
        'tag--large': true,
        'tag--opaque': !this.isQuickStartFilterActive(filter),
        'search__quick-start-tag': true,
        'search__quick-start-tag--active': this.isQuickStartFilterActive(filter)
      });

      return (
        <a href='#' className={filterClasses} onClick={this.submitQuickStartFilterClick.bind(this, filter)} key={'search_quick_start_' + index}>
          {filter.label}
        </a>
      );
    }.bind(this));

    return (
      <div className='search__quick-start'>
        {this.props.quickStartFilters.title ? <p className='search__quick-start-label'>{this.props.quickStartFilters.title}</p> : null}
        <div className='search__quick-start-row'>
          <div className='search__quick-start-items'>
            {items}
            {this.hasActiveQuickStartFilters() && resetLabel ? <button type='button' className='button button--text-inline search__quick-start-reset' onClick={this.resetQuickStartFilters}>{resetLabel}</button> : null}
            {this.props.quickFilterMode && toggleButtonLabel ? <button type='button' className='button button--text-inline search__quick-start-toggle' onClick={this.toggleQuickFilterModeFilters}>{toggleButtonLabel}</button> : null}
          </div>
          {this.renderQuickStartScopeToggle()}
        </div>
      </div>
    );
  }

  submitQueryChange(fieldValue) {
    this.setState({ query: fieldValue });
  }

  isDefaultScopeSelected(searchState = this.state) {
    const initialSearchQuery = this.props.initialSearchQuery || {};
    return searchState.proFilter === this.normalizeProFilterValue(initialSearchQuery.include_pro);
  }

  submitMinLengthClick() {
    let stateObject = this.state;

    stateObject.minLength = '';

    this.setState(stateObject);
    this.sendSearchQuery();
  }

  submitMaxLengthClick() {
    let stateObject = this.state;

    stateObject.maxLength = '';

    this.setState(stateObject);
    this.sendSearchQuery();
  }

  submitLengthChange(minLength, maxLength) {
    if (minLength > 0) {
      this.setState({ minLength: minLength });
    } else {
      this.setState({ minLength: '' });
    }
    if (maxLength > 0) {
      this.setState({ maxLength: maxLength });
    } else {
      this.setState({ maxLength: '' });
    }
  }

  submitExtendedFilterChange(name, value) {
    let shouldChange = false;
    let stateObject = this.state;

    stateObject.extendedFilters[name] = value;

    this.setState(stateObject, function () {
      this.sendSearchQuery();
    });


  }

  submitProFilterChange(value) {
    let stateObject = this.state;

    stateObject.proFilter = value;

    this.setState(stateObject, function () {
      this.sendSearchQuery();
    });
  }

  handleIncludeProCheckboxChange(e) {
    this.submitProFilterChange(e.target.checked ? 0 : this.royaltyFreeProScopeValue());
  }

  activateGemafreeScope() {
    this.submitProFilterChange(this.royaltyFreeProScopeValue());
  }

  activateAllTracksScope() {
    this.submitProFilterChange(0);
  }

  proScopeLabel(scope) {
    const configuredLabels = this.props.proScopeLabels || {};
    if (configuredLabels[scope]) {
      return configuredLabels[scope];
    }

    if (scope === 'royaltyFree') {
      return this.props.locale === 'de' ? 'Nur GEMA-frei' : 'Royalty-free (non P.R.O)';
    }

    return this.props.locale === 'de' ? 'Alle Titel (inkl. PRO)' : 'All tracks';
  }


  isExtendedFilterChecked(name, value) {
    let isChecked = false;

    if (this.state.extendedFilters[name] === value) {
      isChecked = true;
    }

    return isChecked;
  }

  isProFilterChecked(value) {
    let isChecked = false;

    if (this.state.proFilter === value) {
      isChecked = true;
    }

    return isChecked;
  }

  extendedFiltersMenuHighlighted() {
    let isHighlighted = false;

    if (this.state.extendedFilters.drums !== 0 || this.state.extendedFilters.vocals !== 0 || this.state.extendedFilters.withVariants !== 0 || this.state.extendedFilters.loop !== 0) {
      isHighlighted = true
    }

    return isHighlighted;
  }

  proFiltersMenuHighlighted() {
    let isHighlighted = true;
    // let isHighlighted = false;

    // if (this.state.proFilter !== 2) {
    //   isHighlighted = true
    // }

    return isHighlighted;
  }


  submitSortChange(sortBy, sortDirection) {
    let stateObject = {
      sortBy: '',
      sortDirection: ''
    };

    if (sortBy === 'date') {
      stateObject['sortBy'] = sortBy;
    } else if (sortBy === 'popularity') {
      stateObject['sortBy'] = sortBy;
    } else if (sortBy === 'length') {
      stateObject['sortBy'] = sortBy;
    } else {
      stateObject['sortBy'] = '';
    }

    if (sortDirection === 'asc') {
      stateObject['sortDirection'] = sortDirection;
    } else if (sortDirection === 'desc') {
      stateObject['sortDirection'] = sortDirection;
    } else {
      stateObject['sortDirection'] = '';
    }

    this.setState(stateObject, function () {
      this.sendSearchQuery();
    });

  }

  handleSortSelectChange(event) {
    let [sortBy, sortDirection] = event.target.value.split(':');

    this.submitSortChange(sortBy, sortDirection);
  }

  renderSortSelect(className) {
    let currentSortValue = this.state.sortBy && this.state.sortDirection ? this.state.sortBy + ':' + this.state.sortDirection : 'popularity:desc';
    let wrapperClassName = className ? 'search__sort-select-field ' + className : 'search__sort-select-field';

    return (
      <div className={wrapperClassName}>
        <select
          id='search-sort-select'
          className='search__sort-select'
          aria-label={this.props.locale === 'de' ? 'Sortierung' : 'Sort'}
          value={currentSortValue}
          onChange={this.handleSortSelectChange}
        >
          <option value='popularity:desc'>{this.props.locale === 'de' ? 'Sortiert nach Beliebtheit' : 'Sorted by popularity'}</option>
          <option value='length:desc'>{this.props.locale === 'de' ? 'Sortiert nach Dauer (absteigend)' : 'Sorted by duration (longest first)'}</option>
          <option value='length:asc'>{this.props.locale === 'de' ? 'Sortiert nach Dauer (aufsteigend)' : 'Sorted by duration (shortest first)'}</option>
          <option value='date:desc'>{this.props.locale === 'de' ? 'Sortiert nach Neueste' : 'Sorted by most recent'}</option>
        </select>
      </div>
    );
  }

  getActiveSearchCriteriaCount() {
    let criteriaCount = 0;

    if (this.props.hideCategoryFromUrl !== 'tag' && this.state.tags.length > 0) {
      criteriaCount += this.state.tags.length;
    }

    if (this.props.hideCategoryFromUrl !== 'instore_tag' && this.state.instoreTags.length > 0) {
      criteriaCount += this.state.instoreTags.length;
    }

    if (this.props.hideCategoryFromUrl !== 'genre' && this.state.genres.length > 0) {
      criteriaCount += this.state.genres.length;
    }

    if (this.props.hideCategoryFromUrl !== 'instrument' && this.state.instruments.length > 0) {
      criteriaCount += this.state.instruments.length;
    }

    if (this.props.hideCategoryFromUrl !== 'mood' && this.state.moods.length > 0) {
      criteriaCount += this.state.moods.length;
    }

    if (this.state.minLength > 0) {
      criteriaCount += 1;
    }

    if (this.state.maxLength > 0) {
      criteriaCount += 1;
    }

    if ((this.state.query || '').length > 0) {
      criteriaCount += 1;
    }

    return criteriaCount;
  }

  getActiveSearchCriteriaCountWithHiddenCriterias(searchState = this.state) {
    let criteriaCount = 0;

    if (searchState.tags.length > 0) {
      criteriaCount += searchState.tags.length;
    }

    if (searchState.instoreTags.length > 0) {
      criteriaCount += searchState.instoreTags.length;
    }

    if (searchState.genres.length > 0) {
      criteriaCount += searchState.genres.length;
    }

    if (searchState.instruments.length > 0) {
      criteriaCount += searchState.instruments.length;
    }

    if (searchState.moods.length > 0) {
      criteriaCount += searchState.moods.length;
    }

    if (searchState.minLength > 0) {
      criteriaCount += 1;
    }

    if (searchState.maxLength > 0) {
      criteriaCount += 1;
    }

    if ((searchState.query || '').length > 0) {
      criteriaCount += 1;
    }

    return criteriaCount;
  }

  buildSearchQueryParams(omitPageParam) {
    let searchQueryParamsString = '',
      textQuery = '';

    for (let searchCategory in this.state) {
      if (this.state.hasOwnProperty(searchCategory)) {

        if (searchCategory === 'query' && (this.state[searchCategory] || '').length > 0) {
          textQuery = 'q=' + this.state[searchCategory] + '&';
          searchQueryParamsString += textQuery;
        } else if (searchCategory === 'minLength' && this.state[searchCategory] > 0) {
          searchQueryParamsString += 'min_length=' + this.state[searchCategory] + '&';
        } else if (searchCategory === 'maxLength' && this.state[searchCategory] > 0) {
          searchQueryParamsString += 'max_length=' + this.state[searchCategory] + '&';
        } else if (searchCategory === 'minTempo' && this.state[searchCategory] > 0 && this.state.tempoSearchActive) {
          searchQueryParamsString += 'min_tempo=' + this.state[searchCategory] + '&';
        } else if (searchCategory === 'maxTempo' && this.state[searchCategory] > 0 && this.state.tempoSearchActive) {
          searchQueryParamsString += 'max_tempo=' + this.state[searchCategory] + '&';
        } else if (searchCategory === 'trackId') {
          if (parseInt(this.state[searchCategory], 10) > 0) {
            searchQueryParamsString += 'track_id=' + this.state[searchCategory] + '&';
          }
        } else if (searchCategory === 'exposurePackId') {
          if (parseInt(this.state[searchCategory], 10) > 0) {
            searchQueryParamsString += 'exposure_pack_id=' + this.state[searchCategory] + '&';
          }
        } else if (searchCategory === 'mediaBundleId') {
          if (parseInt(this.state[searchCategory], 10) > 0) {
            searchQueryParamsString += 'media_bundle_id=' + this.state[searchCategory] + '&';
          }
        } else if (searchCategory === 'labelId') {
          if (parseInt(this.state[searchCategory], 10) > 0) {
            searchQueryParamsString += 'label_id=' + this.state[searchCategory] + '&';
          }
        } else if (searchCategory === 'albumId') {
          if (parseInt(this.state[searchCategory], 10) > 0) {
            searchQueryParamsString += 'album_id=' + this.state[searchCategory] + '&';
          }
        } else if (searchCategory === 'proFilter') {
          if (this.props.proScopeCheckboxEnabled) {
            if (this.state[searchCategory] === 0) {
              searchQueryParamsString += 'include_pro=true&';
            }
          } else if (this.state[searchCategory] !== 2) {
            searchQueryParamsString += 'include_pro=' + this.state[searchCategory] + '&';
          }
        } else if (searchCategory === 'extendedFilters') {
          if (this.state[searchCategory].drums !== 0) {
            searchQueryParamsString += 'drums=' + this.state[searchCategory].drums + '&';
          }

          if (this.state[searchCategory].vocals !== 0) {
            searchQueryParamsString += 'vocals=' + this.state[searchCategory].vocals + '&';
          }

          // if (this.state[searchCategory].includePro !== 2) {
          //   searchQueryParamsString += 'include_pro=' + this.state[searchCategory].includePro + '&';
          // }

          if (this.state[searchCategory].withVariants !== 0) {
            searchQueryParamsString += 'with_variants=' + this.state[searchCategory].withVariants + '&';
          }

          if (this.state[searchCategory].loop !== 0) {
            searchQueryParamsString += 'loop=' + this.state[searchCategory].loop + '&';
          }

        } else if (searchCategory === 'page') {
          if (omitPageParam) {
            searchQueryParamsString += 'page=' + this.state[searchCategory] + '&';
          }
        } else if (searchCategory === 'sortBy' && typeof this.state[searchCategory] === 'string') {
          searchQueryParamsString += 'sort_by=' + this.state[searchCategory] + '&';
        } else if (searchCategory === 'sortDirection' && typeof this.state[searchCategory] === 'string') {
          searchQueryParamsString += 'sort_direction=' + this.state[searchCategory] + '&';
        } else if (searchCategory === 'free' && this.state[searchCategory] === true) {
          searchQueryParamsString += 'free=' + this.state[searchCategory] + '&';
        } else if (searchCategory === 'completedQuery') {

        } else if (Array.isArray(this.state[searchCategory])) {
          for (let i = 0; i < this.state[searchCategory].length; i += 1) {
            let elementValue = this.state[searchCategory][i],
              singularCategory = searchCategory.slice(0, -1),
              text = '';

            // if (this.props.hideCategoryFromUrl !== singularCategory) {
            //     text = singularCategory + '_id[]=' + elementValue + '&';
            // }

            text = singularCategory + '_id[]=' + elementValue + '&';

            searchQueryParamsString += text;
          }
        }
      }
    }


    if (searchQueryParamsString.endsWith('&')) {
      searchQueryParamsString = searchQueryParamsString.slice(0, -1);
    }

    if (searchQueryParamsString === 'sort_direction=&sort_by=') {
      searchQueryParamsString = '';
    }

    return searchQueryParamsString;
  }

  sendSearchQuery(paginationMode, initialPageLoadQuery, options = {}) {
    let that = this,
      searchQueryParams, // search object
      newUrl,
      urlParams;
    const skipHistoryPush = options.skipHistoryPush === true;
    const skipResultsScroll = options.skipResultsScroll === true;
    const useAnimationlessUpdate = options.useAnimationlessUpdate === true;

    if (!paginationMode) {
      this.setState({ page: 1 });
    }

    searchQueryParams = this.buildSearchQueryParams(paginationMode) || ''; // search object
    urlParams = (searchQueryParams.length > 0 ? ('?' + searchQueryParams) : '');

    if (initialPageLoadQuery || useAnimationlessUpdate) {
      this.triggerEventHub('fireSearchWithoutAnimation');
    } else {
      this.triggerEventHub('fireSearch');
    }

    return requestJson('/tracks/search_results' + urlParams).then((data) => {
        if (initialPageLoadQuery) {
          this.triggerEventHub('initialUpdateTrackListing', data);
        } else {
          this.triggerEventHub('updateTrackListing', data);
          if (!paginationMode && !skipResultsScroll) {
            that.scheduleResultsScroll('search');
          }
        }

        this.triggerEventHub('searchSuccess', data);
        that.syncItemIdList();
        if (history.pushState && !initialPageLoadQuery && !skipHistoryPush) {
          if (paginationMode) {
            var prevParams = (location.search || '').replace(/\?page=[\d]+/, '').replace(/&page=[\d]+/, '').replace(/[\?]+/, '');
            var path = window.location.pathname + '?' + prevParams + (prevParams.length > 0 ? '&' : '') + 'page=' + (that.state.page);
            if (path === '?') {
              path = '';
            }
            newUrl = window.location.protocol + "//" + window.location.host + path;
            newUrl = newUrl.replace(/\?page=1$/, '').replace(/&page=1$/, '');
          } else {
            var path = (searchQueryParams.length > 0 ? ('?' + searchQueryParams) : '').replace('?sort_direction=&sort_by=', '?').replace('&sort_direction=&sort_by=', '').replace('&sort_direction=desc&sort_by=popularity', '').replace('?sort_direction=desc&sort_by=popularity', '?');

            if (path === '?') {
              path = ''
            }

            newUrl = window.location.protocol + "//" + window.location.host + (window.location.pathname || '') + path;
            newUrl = newUrl.replace(/&page=[\d]+/, '');
          }

          if ((that.props.hideCategoryFromUrl || '').length > 0) {
            if (that.props.hideCategoryFromUrl === 'tag') {
              newUrl = newUrl.replace(/\?tag_id\[\]=[\d]+&/, '?');
              newUrl = newUrl.replace(/&tag_id\[\]=[\d]+&/, '&');
              newUrl = newUrl.replace(/&tag_id\[\]=[\d]+/, '');
              newUrl = newUrl.replace(/\?tag_id\[\]=[\d]+/, '');
            }

            if (that.props.hideCategoryFromUrl === 'instore_tag') {
              newUrl = newUrl.replace(/\?instore_tag_id\[\]=[\d]+&/, '?');
              newUrl = newUrl.replace(/&instore_tag_id\[\]=[\d]+&/, '&');
              newUrl = newUrl.replace(/&instore_tag_id\[\]=[\d]+/, '');
              newUrl = newUrl.replace(/\?instore_tag_id\[\]=[\d]+/, '');
            }

            if (that.props.hideCategoryFromUrl === 'genre') {
              newUrl = newUrl.replace(/\?genre_id\[\]=[\d]+&/, '?');
              newUrl = newUrl.replace(/&genre_id\[\]=[\d]+&/, '&');
              newUrl = newUrl.replace(/&genre_id\[\]=[\d]+/, '');
              newUrl = newUrl.replace(/\?genre_id\[\]=[\d]+/, '');
            }

            if (that.props.hideCategoryFromUrl === 'composer') {
              newUrl = newUrl.replace(/\?composer_id\[\]=[\d]+&/, '?');
              newUrl = newUrl.replace(/&composer_id\[\]=[\d]+&/, '&');
              newUrl = newUrl.replace(/&composer_id\[\]=[\d]+/, '');
              newUrl = newUrl.replace(/\?composer_id\[\]=[\d]+/, '');
            }

          }

          window.history.pushState({ path: newUrl }, '', newUrl);

          if (typeof ga === 'function') {
            ga('send', 'pageview', path);
          }

          that.setState({ completedQuery: that.state.query || '' });
        } else {
          that.setState({ completedQuery: that.state.query || '' });
        }
      }).catch(function(error) {
        this.triggerEventHub('searchFailure', { error: error, scope: 'tracks' });
        console.warn('Search request failed', error);
        return null;
      }.bind(this));
  }

  renderSearchInputs(stickyMode = false) {
    let tagsTabClassName = this.shouldShowMobilePrimaryTagsTab() ? 'search__filter search__filter--mobile-primary' : 'search__filter search__filter--mobile-secondary';
    let genresTabClassName = this.shouldShowMobilePrimaryGenresTab() ? 'search__filter search__filter--mobile-primary' : 'search__filter search__filter--mobile-secondary';
    let moodsTabClassName = this.shouldShowMobilePrimaryMoodsTab() ? 'search__filter search__filter--mobile-primary' : 'search__filter search__filter--mobile-secondary';
    let proFilterTabClassName = this.shouldShowMobilePrimaryScopeToggle() ? 'search__filter search__filter--mobile-secondary' : 'search__filter search__filter--mobile-secondary';
    let inputsClassName = 'search__inputs';

    if (stickyMode) {
      inputsClassName += ' search__inputs--sticky-clone';
    }

    if (this.state.mobileFiltersExpanded) {
      inputsClassName += ' search__inputs--mobile-filters-expanded';
    }

    if (this.shouldUseTwoColumnMobilePrimaryTabs()) {
      if (this.shouldShowMobilePrimaryTagsTab()) {
        tagsTabClassName += this.mobilePrimaryFilterPosition('tags') === 0 ? ' search__filter--mobile-half search__filter--mobile-half-left' : ' search__filter--mobile-half search__filter--mobile-half-right';
      }

      if (this.shouldShowMobilePrimaryGenresTab()) {
        genresTabClassName += this.mobilePrimaryFilterPosition('genres') === 0 ? ' search__filter--mobile-half search__filter--mobile-half-left' : ' search__filter--mobile-half search__filter--mobile-half-right';
      }

      if (this.shouldShowMobilePrimaryMoodsTab()) {
        moodsTabClassName += this.mobilePrimaryFilterPosition('moods') === 0 ? ' search__filter--mobile-half search__filter--mobile-half-left' : ' search__filter--mobile-half search__filter--mobile-half-right';
      }
    }

    return (
      <div className={inputsClassName}>
        <div className="search__bar-wrapper">
          <SearchTabs activeTab={this.state.activeTab} onActiveTabChange={this.handleSearchTabChange}>
              {this.props.proScopeCheckboxEnabled && !this.props.includeProSwitchInQuickFilters ? (
                <div className='search-license-scope-toggle hide-md-down'>
                  <button
                    type='button'
                    className={this.state.proFilter === this.royaltyFreeProScopeValue() ? 'search-license-scope-toggle__option search-license-scope-toggle__option--active' : 'search-license-scope-toggle__option'}
                    onClick={this.activateGemafreeScope.bind(this)}
                  >
                    <span className='search-license-scope-toggle__label'>
                      {this.proScopeLabel('royaltyFree')}
                    </span>
                  </button>
                  <button
                    type='button'
                    className={this.state.proFilter === 0 ? 'search-license-scope-toggle__option search-license-scope-toggle__option--active' : 'search-license-scope-toggle__option'}
                    onClick={this.activateAllTracksScope.bind(this)}
                  >
                    <span className='search-license-scope-toggle__label'>
                      {this.proScopeLabel('all')}
                    </span>
                  </button>
                </div>
              ) : null}
              {this.props.proScopeCheckboxEnabled && !this.props.includeProSwitchInQuickFilters ? (
                <div className='search-license-scope-toggle search-license-scope-toggle--mobile show-md-down search__filter search__filter--mobile-primary'>
                  <button
                    type='button'
                    className={this.state.proFilter === this.royaltyFreeProScopeValue() ? 'search-license-scope-toggle__option search-license-scope-toggle__option--active' : 'search-license-scope-toggle__option'}
                    onClick={this.activateGemafreeScope.bind(this)}
                  >
                    <span className='search-license-scope-toggle__label'>
                      {this.proScopeLabel('royaltyFree')}
                    </span>
                  </button>
                  <button
                    type='button'
                    className={this.state.proFilter === 0 ? 'search-license-scope-toggle__option search-license-scope-toggle__option--active' : 'search-license-scope-toggle__option'}
                    onClick={this.activateAllTracksScope.bind(this)}
                  >
                    <span className='search-license-scope-toggle__label'>
                      {this.proScopeLabel('all')}
                    </span>
                  </button>
                </div>
              ) : null}
              {this.props.proScopeCheckboxEnabled ? null : (
                <SearchTab itemNames='proFilter' locale={this.props.locale} title={this.props.locale === 'de' ? 'GEMA Filter' : 'P.R.O. filter'} items={this.props.proFilter} activeItems={this.state.proFilter} proFilter={true} iconClassName='bell' highlighted={this.proFiltersMenuHighlighted()} className={proFilterTabClassName}>
                  <SearchTabProFilterContent locale={this.props.locale} items={this.props.proFilters} activeItems={[{ name: 'includePro', value: this.state.proFilter }]} name='proFilter' submitProFilterChange={this.submitProFilterChange} isProFilterChecked={this.isProFilterChecked} />
                </SearchTab>
              )}
              {this.shouldShowTagsFilter() ? (
                <SearchTab itemNames='tags' locale={this.props.locale} title={this.props.i18n.titles[4]} items={this.props.tags} activeItems={this.state.tags} iconClassName='tags' highlighted={this.state.tags.length > 0} counter={this.state.tags.length} className={tagsTabClassName}>
                  <SearchTabContent locale={this.props.locale} items={this.props.tags} name='tags' activeItems={this.state.tags} submitMenuItemClick={this.submitMenuItemClick} />
                </SearchTab>
              ) : null}
              {this.shouldShowGenresFilter() ? (
              <SearchTab itemNames='genres' locale={this.props.locale} title={this.props.i18n.titles[1]} items={this.props.genres} activeItems={this.state.genres} iconClassName='tag' highlighted={this.state.genres.length > 0} counter={this.state.genres.length} className={genresTabClassName}>
                <SearchTabContent locale={this.props.locale} items={this.props.genres} activeItems={this.state.genres} name='genres' submitMenuItemClick={this.submitMenuItemClick} />
              </SearchTab>
              ) : null}
              {this.shouldShowMoodsFilter() ? (
                <SearchTab itemNames='moods' locale={this.props.locale} title={this.props.i18n.titles[3]} items={this.props.moods} activeItems={this.state.moods} iconClassName='smile-o' highlighted={this.state.moods.length > 0} counter={this.state.moods.length} className={moodsTabClassName}>
                  <SearchTabContent locale={this.props.locale} items={this.props.moods} name='moods' activeItems={this.state.moods} submitMenuItemClick={this.submitMenuItemClick} />
                </SearchTab>
              ) : null}
              {this.renderMobileFiltersToggle()}
              {this.shouldShowInstrumentsFilter() ? (
                <SearchTab itemNames='instruments' locale={this.props.locale} title={this.props.i18n.titles[2]} items={this.props.instruments} activeItems={this.state.instruments} iconClassName='bell' highlighted={this.state.instruments.length > 0} counter={this.state.instruments.length} className='search__filter search__filter--mobile-secondary'>
                  <SearchTabContent locale={this.props.locale} items={this.props.instruments} activeItems={this.state.instruments} name='instruments' submitMenuItemClick={this.submitMenuItemClick} />
                </SearchTab>
              ) : null}
              {this.shouldShowExtendedFilters() ? (
                <SearchTab itemNames='extendedFilters' locale={this.props.locale} title={this.props.locale == 'de' ? 'Weitere Filter' : 'More filters'} items={this.props.extendedFilters} activeItems={this.state.extendedFilters} iconClassName='bell' highlighted={this.extendedFiltersMenuHighlighted()} counter={this.state.extendedFilters.length} className='search__filter search__filter--mobile-secondary'>
                  <SearchTabFilterContent items={this.props.extendedFilters} activeItems={[{ name: 'drums', value: this.state.extendedFilters['drums'] }, { name: 'vocals', value: this.state.extendedFilters['vocals'] }, { name: 'withVariants', value: this.state.extendedFilters['withVariants'] }, { name: 'loop', value: this.state.extendedFilters['loop'] }]} name='extendedFilters' submitExtendedFilterChange={this.submitExtendedFilterChange} isExtendedFilterChecked={this.isExtendedFilterChecked} />
                </SearchTab>
              ) : null}

              {this.shouldShowLengthFilter() ? <SearchMenuLengthInputs locale={this.props.locale} minLength={this.state.minLength} maxLength={this.state.maxLength} submitLengthChange={this.submitLengthChange} className='search__filter search__filter--mobile-secondary' /> : null}
              {this.shouldShowQueryFilter() ? <SearchMenuQueryInput query={this.state.query} submitQueryChange={this.submitQueryChange} placeholder={this.props.i18n.placeholder} autocompletion={this.props.autocompletion} className='search__filter search__filter--mobile-secondary' /> : null}
              {this.shouldShowSortFilter() ? this.renderSortSelect('search__filter search__filter--mobile-secondary') : null}
          </SearchTabs>
        </div>
      </div>
    );
  }

  render() {
    let classes = classNames({
      'search': true,
      'search--quick-filter-mode': this.props.quickFilterMode,
      'search--quick-filter-mode-expanded': this.props.quickFilterMode && this.state.quickFiltersExpanded,
      'search--mobile-filters-expanded': this.state.mobileFiltersExpanded
    });

    let searchCombinationHint;

    if (this.getActiveSearchCriteriaCountWithHiddenCriterias() !== 0 && this.getActiveSearchCriteriaCountWithHiddenCriterias() === this.state.tags.length) {
      // only tags activated
      searchCombinationHint = (<p className='text-size-small margin-bottom0'><strong>{this.props.locale === 'de' ? 'TIPP' : 'HINT'}</strong>: {this.props.locale === 'de' ? 'Nutzen Sie zusätzlich den Stimmungen-Filter für eine genauere Eingrenzung.' : 'Additionally, use the mood filter for a more precise narrowing down.'}</p>)
    } else if (this.getActiveSearchCriteriaCountWithHiddenCriterias() !== 0 && this.getActiveSearchCriteriaCountWithHiddenCriterias() === this.state.genres.length) {
      searchCombinationHint = (<p className='text-size-small margin-bottom0'><strong>{this.props.locale === 'de' ? 'TIPP' : 'HINT'}</strong>: {this.props.locale === 'de' ? 'Nutzen Sie zusätzlich den Stimmungen-Filter für eine genauere Eingrenzung.' : 'Additionally, use the mood filter for a more precise narrowing down.'}</p>)
    } else if (this.getActiveSearchCriteriaCountWithHiddenCriterias() !== 0 && this.getActiveSearchCriteriaCountWithHiddenCriterias() === this.state.moods.length) {
      searchCombinationHint = (<p className='text-size-small margin-bottom0'><strong>{this.props.locale === 'de' ? 'TIPP' : 'HINT'}</strong>: {this.props.locale === 'de' ? 'Nutzen Sie zusätzlich den Themen- oder Genres-Filter für eine genauere Eingrenzung.' : 'Additionally, use the topic or genre filter for a more precise narrowing.'}</p>)
    } else if (this.getActiveSearchCriteriaCountWithHiddenCriterias() === 0) {
      searchCombinationHint = (<p className='text-size-small margin-bottom0'><strong>{this.props.locale === 'de' ? 'TIPP' : 'HINT'}</strong>: {this.props.locale === 'de' ? 'Nutzen Sie den Thema-Filter, um schnell zur passenden Musik zu kommen.' : 'Use the topic filter to quickly find the music you need'}</p>)
    }

    return (
      <div className={classes} ref={this.setSearchRef}>
        {this.renderQuickStartFilters()}
        <div className='search__sticky-region' ref={this.setStickyRegionRef}>
          {this.renderSearchInputs()}
        </div>
        <div className='search__hint'>
          {searchCombinationHint}
        </div>
      </div>
    )
  }
};

Search.defaultProps = {
  genres: [
    {
      name: '',
      id: ''
    }
  ],
  instruments: [
    {
      name: '',
      id: ''
    }
  ],
  moods: [
    {
      name: '',
      id: ''
    }
  ],
  composers: [
    {
      name: '',
      id: ''
    }
  ],
  sortDirection: 'desc',
  sortBy: 'popularity',
  initialSearchQuery: {
    // query : '',
    // free : false,
    // genres : [],
    // instruments : [],
    // moods : [],
    // tags  : [],
    // instoreTags  : [],
    // minTempo : 80,
    // maxTempo : 140,
    // tempoSearchActive : false,
    // page : 1,
    // composers : [],
    // trackId : undefined,
    // aId : 1,
    // albumId : 1

  },
  autocompletion: [],
  i18n: {
    placeholder: 'z.B. Urlaub Gitarre fröhlich'
  },
  proScopeCheckboxEnabled: true,
  proScopeDefaultValue: null,
  proScopeRoyaltyFreeValue: 2,
  includeProSwitchInQuickFilters: false,
  mobilePrimaryFilters: null,
  quickFilterMode: false,
  quickStartFilters: {
    title: '',
    resetLabel: '',
    items: []
  },
  hideCategoryFromUrl: '',
  extendedFilters: [
    { category: 'drums', nameDe: 'Schlagzeug / Beat', nameEn: 'Drums / beat', value: undefined, labelsDe: ['Beliebig', 'Mit Beat', 'Ohne Beat'], labelsEn: ['Any', 'With beat', 'Without beat'] },
    { category: 'vocals', nameDe: 'Gesang / Stimme', nameEn: 'Singing / vocals', value: undefined, labelsDe: ['Beliebig', 'Mit Gesang', 'Ohne Gesang'], labelsEn: ['Any', 'With vocals', 'Without vocals'] },
    { category: 'withVariants', nameDe: 'Varianten / Stems', nameEn: 'Variants / stems', value: undefined, labelsDe: ['Beliebig', 'Mit Varianten', 'Ohne Varianten'], labelsEn: ['Any', 'With variants', 'Without variants'] },
    { category: 'loop', nameDe: 'Loop', nameEn: 'Loop', value: undefined, labelsDe: ['Beliebig', 'Mit Loops', 'Ohne Loops'], labelsEn: ['Any', 'With loops', 'Without loops'] },
  ],
  proFilters: [
    { category: 'includePro', nameDe: 'Verwertungsgesellschaft', nameEn: 'P.R.O.', value: undefined, labelsDe: ['Alle Tracks', 'Nur GEMA-pflichtig (P.R.O.)', 'Nur GEMA-frei'], labelsEn: ['Any', 'Only P.R.O. tracks', 'Only royalty free tracks'] }
  ]
}

Search.propTypes = {
  locale: PropTypes.string,
  proScopeDefaultValue: PropTypes.number,
  proScopeRoyaltyFreeValue: PropTypes.number,
  includeProSwitchInQuickFilters: PropTypes.bool,
  mobilePrimaryFilters: PropTypes.array
};


// INIT

let elements = document.querySelectorAll('[data-react-component=Search]');

elements.forEach(function (element) {
  let reactProps = parseReactProps(element.dataset.reactProps);

  ReactDOM.render(
    <React.StrictMode>
      <Search {...reactProps} />
    </React.StrictMode>,
    element
  );
})

export default Search;
